import { render, staticRenderFns } from "./ReservationCardDetails.vue?vue&type=template&id=0538f1ba&scoped=true&"
import script from "./ReservationCardDetails.vue?vue&type=script&lang=ts&"
export * from "./ReservationCardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationCardDetails.vue?vue&type=style&index=0&id=0538f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0538f1ba",
  null
  
)

export default component.exports